import { Facilitator } from "./facilitator";
import { SharedFilesComponent } from "../schoolPrograms/sharedFiles/sharedFiles";


export const FacilitatorSchoolFilesComponent = () => {
  
    return (<>
        <Facilitator>


            <SharedFilesComponent
                eabhyasFilesAdd={true}
                eabhyasFilesDelete={true}
                eabhyasFilesShare={true}
                schoolFilesAdd={false}
                schoolFilesDelete={false}
                notificationFilesAdd={true}
                notificationFilesDelete={true}
                schoolSwitch={true}
            ></SharedFilesComponent>






        </Facilitator>

    </>);
}